const bookPath = (bookId) => `/books/${encodeURIComponent(bookId)}`;
const appBookPath = (bookId) => `/app/books/${encodeURIComponent(bookId)}`;
export const wave4RoutePatterns = {
    memoryIndex: "/app/books/:bookId/memory-index",
    timeline: "/app/books/:bookId/timeline",
    language: "/app/books/:bookId/language",
    accessibility: "/app/books/:bookId/accessibility",
    bookType: "/app/books/:bookId/book-type",
};
export const wave4Routes = {
    memoryIndex: (bookId) => `${appBookPath(bookId)}/memory-index`,
    timeline: (bookId) => `${appBookPath(bookId)}/timeline`,
    language: (bookId) => `${appBookPath(bookId)}/language`,
    accessibility: (bookId) => `${appBookPath(bookId)}/accessibility`,
    bookType: (bookId) => `${appBookPath(bookId)}/book-type`,
};
export const wave4ApiRoutes = {
    people: (bookId) => `${bookPath(bookId)}/memory-index/people`,
    places: (bookId) => `${bookPath(bookId)}/memory-index/places`,
    events: (bookId) => `${bookPath(bookId)}/memory-index/events`,
    playlists: (bookId) => `${bookPath(bookId)}/memory-index/playlists`,
    playlistSongs: (bookId, playlistId) => `${bookPath(bookId)}/memory-index/playlists/${encodeURIComponent(playlistId)}/songs`,
    familyTreeEdges: (bookId) => `${bookPath(bookId)}/memory-index/family-tree-edges`,
    sourceRevisions: (bookId) => `${bookPath(bookId)}/localization/source-revisions`,
    translationRevisions: (bookId) => `${bookPath(bookId)}/localization/translations`,
    readingPreferences: (bookId) => `${bookPath(bookId)}/accessibility/preferences`,
    bookType: (bookId) => `${bookPath(bookId)}/book-type`,
};
//# sourceMappingURL=wave4-routes.js.map